import i18n from '@/plugins/vuei18n'

export default [
    {
        id: 1,
        countable: true,
        shortcut: "szt.",
        label: i18n.t('units.piece')
    },
    {
        id: 2,
        countable: true,
        shortcut: "mb",
        label: i18n.t('units.runningMeter')
    },
    {
        id: 3,
        countable: true,
        shortcut: "m²",
        label: i18n.t('units.squaredMeter')
    },
    {
        id: 4,
        countable: true,
        shortcut: "",
        label: i18n.t('units.joistRow')
    },
    {
        id: 5,
        countable: true,
        shortcut: "op",
        label: i18n.t('units.package')
    },
    {
        id: 0,
        countable: false,
        shortcut: "u",
        label: i18n.t('units.service')
    }
]
